import styled from 'styled-components';

interface BackgroundProps {
  backgroundImage: string | null | undefined;
  backgroundColor: string | null;
  isEdition: undefined | boolean;
}

export const BackgroundContainer = styled.div<BackgroundProps>`
  -webkit-touch-callout: none; // iOS Safari
  -webkit-user-select: none; // Safari
  -khtml-user-select: none; // Konqueror HTML
  -moz-user-select: none; // Old versions of Firefox
  -ms-user-select: none; // Internet Explorer/Edge
  user-select: none; // Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox

  height: 96vh;
  width: 96vw;
  margin: 2vh;
  box-shadow: 0 0 2vh rgba(0, 0, 0, 0.2);
  position: absolute;
  border-radius: 3vw;
  ${({ backgroundImage, backgroundColor }): string => {
    const backgroundImageCss = backgroundImage === null || backgroundImage === undefined
      ? ''
      : `center / contain no-repeat url("${backgroundImage}")`;
    const backgroundColorCss = backgroundColor === null
      ? ''
      : backgroundColor;
    return backgroundImageCss || backgroundColorCss
      ? `background: ${backgroundImageCss} ${backgroundColorCss};`
      : '';
  }}
  ${(props): string => {
    if (props.isEdition === true) {
      return `
        &:hover {
          -webkit-box-shadow: inset 0 0 2px 0 black;
          box-shadow: inset 0 0 2px 0 black;
        }
      `;
    }
    return '';
  }}
`;
BackgroundContainer.displayName = 'BackgroundContainer';
